var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-cr"},[_vm._v(" Copyright © 2021 Passport. All rights reserved. ")]),_c('div',{staticClass:"footer-logo"},[_c('img',{attrs:{"src":require("../../img/logoAppIcon.png"),"alt":""}})]),_c('div',{staticClass:"footer-shadow"})])
}]

export { render, staticRenderFns }